/**
 * The terminal's display vocabulary: how an asset class, an income type and a transaction kind
 * are labelled and coloured.
 *
 * <p>Shared between the page and its panels, so a class renamed here is renamed everywhere at
 * once rather than in whichever files were remembered.
 */

export const CLASS_RU: Record<string, string> = {
  STOCK: 'Stocks',
  ETF: 'ETF',
  OPTION: 'Options',
  CRYPTO: 'Crypto',
  CASH: 'Cash',
  CUSTOM: 'Custom',
}

export const BADGE_FOR_CLASS: Record<string, string> = {
  STOCK: 'badge-stock',
  ETF: 'badge-stock',
  OPTION: 'badge-stock',
  CRYPTO: 'badge-crypto',
  CASH: 'badge-re',
  CUSTOM: 'badge-custom',
}

export const BADGE_FOR_TYPE: Record<string, string> = {
  DIVIDEND: 'badge-stock',
  INTEREST: 'badge-re',
  STAKING_REWARD: 'badge-crypto',
  RENTAL_INCOME: 'badge-custom',
}

export const FLOW_RU: Record<string, string> = {
  DIVIDEND: 'Dividend',
  INTEREST: 'Interest',
  STAKING_REWARD: 'Staking',
  RENTAL_INCOME: 'Rent',
}
